import { ISession } from "@augloop/runtime-client";
import { ErrorStringFromException, isEmptyString, isNullOrUndefined } from "../../../utils/utils";
import { EnsureAugloopRuntimeManager, waitForAugloopConnectionToBeConnected } from "../../augloop/Augloop";
import { IdentityType, PrimaryIdentityInfo, GetAccessTokenOptions } from "../../interfaces/IAuthenticationProvider";
import { TokenProvisionMessage } from "@augloop/session-protocol";
import { GetAugloopResourceUrl } from "../../augloop/AugloopConfig";
import { LogError } from "../../../utils/ErrorTelemetry";
import { LogEventNames } from "../../interfaces/ITelemetryLogger";
import { IAuthenticationProvider } from "../../interfaces/IAuthenticationProvider";
import { IS_DEV_BUILD } from "../../../AppConstants";

export async function GetPrimaryIdentity() {
  return await GetPrimaryIdentityInfo();
}

export function IsPrimaryIdentityInformationValid(primaryIdentity: PrimaryIdentityInfo | null) {
  if (!isNullOrUndefined(primaryIdentity) && (primaryIdentity?.displayName != undefined && !isEmptyString(primaryIdentity?.displayName))
    && (primaryIdentity?.email != undefined && !isEmptyString(primaryIdentity?.email))) {
    return true;
  }
  return false;
}

export async function GetPrimaryIdentityInfo(): Promise<PrimaryIdentityInfo> {
  //Note: getPrimaryIdentityInfo is called to get the primary identity type of the accounts logged in.
  const primaryIdentityValue = await OfficeFirstPartyAuth.getPrimaryIdentityInfo();
  const identityType = primaryIdentityValue.identityType;

  switch (identityType) {
      case IdentityType.ODP:
          return { type: IdentityType.ODP, displayName : primaryIdentityValue.displayName, email : primaryIdentityValue.email };
      case IdentityType.ODB:
          return { type: IdentityType.ODB, displayName : primaryIdentityValue.displayName, email : primaryIdentityValue.email };
      default:
          return { type: IdentityType.Unsupported, displayName : primaryIdentityValue.displayName, email : primaryIdentityValue.email };
  }
}

export async function ProvisionAuthenticationToken(authProvider: IAuthenticationProvider): Promise<boolean> {
  try {
    const alRuntimeManager = await EnsureAugloopRuntimeManager();
    await waitForAugloopConnectionToBeConnected();

    const resource = GetAugloopResourceUrl(authProvider.GetAuthEnvironment());

    // Get user identity information to determine if it's a Consumer user.
    // In dev, getPrimaryIdentityInfo is unavailable so we force enterprise identity.
    let options: GetAccessTokenOptions;
    if (!IS_DEV_BUILD) {
      const primaryIdentityInfo = await GetPrimaryIdentityInfo();
      if (primaryIdentityInfo.type === IdentityType.ODP) {
        options = {
          resource: resource,
          scope: `${resource}/AugLoop.All`,
          policy: 'DELEGATED'
        };
      } else {
        options = { resource: resource };
      }
    } else {
      // For enterprise users, only pass resource
      options = { resource: resource };
    }
    const token = await authProvider.GetAccessToken(options);

    const session: ISession = await alRuntimeManager.getSession();
    await session.submitCustomMessage(new TokenProvisionMessage({ authToken: token }));
    return true;
  } catch (error) {
    LogError(LogEventNames.Boot, "Failed to get token: " + ErrorStringFromException(error));
    // Bypass the issue if get token failed since token is not required for CTS
    return false;
  }
}